import axios from "axios";

export default {
    Reason: {
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/incidentoperations/incidentreason/update" : "/api/incidentoperations/incidentreason/create", data);
            return response;
        },
        async Table(data) {
            const response = await axios.post("/api/incidentoperations/incidentreason/table", data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/incidentoperations/incidentreason/delete/${data}`);
            return response;
        },
        async List() {
            const response = await axios.get("/api/incidentoperations/incidentreason/list");
            return response;
        },
    },
    ApprovalConfiguration: {
        async CreateOrUpdate(update, data) {
            const url = update ? "/api/incidentoperations/approvalconfiguration/update" : "/api/incidentoperations/approvalconfiguration/create";
            const response = await axios.post(url, data);
            return response;
        },
        async Table(data) {
            const response = await axios.post("/api/incidentoperations/approvalconfiguration/table", data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/incidentoperations/approvalconfiguration/delete/${id}`);
            return response;
        },
    },
    async CreateOrUpdate(update, data) {
        const response = await axios.post(update ? "/api/incidentoperations/incident/update" : "/api/incidentoperations/incident/create", data, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response;
    },
    async Table(data) {
        const response = await axios.post("/api/incidentoperations/incident/table", data);
        return response;
    },
    // async Delete(data) {
    //     const response = await axios.post(`/api/incidentoperations/incident/delete/${data}`);
    //     return response;
    // },
    async Deactivate(payload) {
        const response = await axios.post(`/api/incidentoperations/incident/deactivate`, payload);
        return response;
    },
    async GetApprovers(incidentId) {
        const response = await axios.get(`/api/incidentoperations/getapprovers/${incidentId}`);
        return response;
    },
    async Get(data) {
        const response = await axios.get(`/api/incidentoperations/incident/get/${data}`);
        return response;
    },
    async List() {
        const response = await axios.get("/api/incidentoperations/incident/list");
        return response;
    },
    async CalculateInstallment(installmentCount, totalAmount, month, year) {
        const response = await axios.get(`/api/incidentoperations/incident/calculateinstallment/${installmentCount}/${totalAmount}/${month}/${year}`);
        return response;
    },
    async payDeposit(data) {
        const response = await axios.post("/api/incidentoperations/incident/deposit/pay", data);
        return response;
    },
    async myApprovals() {
        var response = await axios.get("/api/incidentoperations/myapprovals");
        return response;
    },
    async GetTaskWithOTT(q) {
        const response = await axios.get(`/api/incidentoperations/getincidentwithott/${q.trim()}`);
        return response;
    },
    async ChangeApprovalStatusWithOTT(data) {
        const response = await axios.post("/api/incidentoperations/changeapprovalstatuswithott", data);
        return response;
    },
    async ChangeApprovalStatus(id, approve, description) {
        const response = await axios.post(`/api/incidentoperations/changeapprovalstatus/${id}/${approve}/${description}`);
        return response;
    },
    CaseCategory: {
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/incidentoperations/case/category/update" : "/api/incidentoperations/case/category/create", data);
            return response;
        },
        async Table(data) {
            const response = await axios.post("/api/incidentoperations/case/category/table", data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/incidentoperations/case/category/delete/${id}`);
            return response;
        },
        async List() {
            const response = await axios.get("/api/incidentoperations/case/category/list");
            return response;
        },
    },
    CaseType: {
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/incidentoperations/case/type/update" : "/api/incidentoperations/case/type/create", data);
            return response;
        },
        async Table(data) {
            const response = await axios.post("/api/incidentoperations/case/type/table", data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/incidentoperations/case/type/delete/${id}`);
            return response;
        },
        async List() {
            const response = await axios.get("/api/incidentoperations/case/type/list");
            return response;
        },
        async ListWithCategoryId(categoryId) {
            const response = await axios.get(`/api/incidentoperations/case/type/list/${categoryId}`);
            return response;
        },
    },
    async TreeView(){
        const response = await axios.get("/api/incidentoperations/case/treeview");
        return response;
    },
    async FlatList(){
        const response = await axios.get("/api/incidentoperations/case/flatview");
        return response;
    },
    async FlatListCategoryId(categoryId){
        const response = await axios.get(`/api/incidentoperations/case/flatview/${categoryId}`);
        return response;
    }
};
